__turbopack_context__.v({
  "active": "site-header-module__wBaYfG__active",
  "brand": "site-header-module__wBaYfG__brand",
  "header": "site-header-module__wBaYfG__header",
  "link": "site-header-module__wBaYfG__link",
  "logo": "site-header-module__wBaYfG__logo",
  "nav": "site-header-module__wBaYfG__nav",
});
